import { IBranch } from "@/api/AppApi/services/company/interfaces/ICompany";
import SiteGoogleMap from "@/app/components/lib/googlemaps/SiteGoogleMap";
import BranchDetails from "@/app/components/pages-components/user-pages/orders-page/order-details/order-details-helpers/branch-details/BranchDetails";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Modal } from "@/utils/bootstrap";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  branch: IBranch;
  inPopUp?: boolean;
  onCloseInPopuUp?: () => void;
}
const BranchDetailsPopup: React.FC<Props> = ({
  show,
  setShow,
  branch,
  inPopUp,
  onCloseInPopuUp,
}) => {
  const mobile = useIsMobile();

  const mCLass = mobile ? "mobile-popup" : "";
  const modalClassName = mobile
    ? "modal-as-swipeable-drawer drawer up-align"
    : "";
  const dialogClassName = !mobile ? "messagebox-dialog" : "";
  const contentClassName = mobile
    ? "dialog-swipeable-drawer"
    : "locaton-details-dialog-content";
  return (
    <>
      {inPopUp ? (
        <div>
          <SiteGoogleMap
            width={mobile ? "100vw" : "100%"}
            height={274}
            position={branch?.map_location}
            setPosition={() => {}}
            viewOnly
          />
          <BranchDetails
            onCloseInPopuUp={onCloseInPopuUp}
            branch={branch}
            isCheckout
          />
        </div>
      ) : (
        <Modal
          centered={!mobile}
          show={show}
          onHide={() => setShow(false)}
          // dialogClassName="messagebox-dialog"
          // contentClassName="locaton-details-dialog-content"

          className={modalClassName}
          dialogClassName={dialogClassName}
          contentClassName={contentClassName}
        >
          <div className={mCLass} style={!mobile ? { width: 758 } : {}}>
            <SiteGoogleMap
              width={mobile ? "100%" : 758}
              height={274}
              position={branch?.map_location}
              setPosition={() => {}}
              viewOnly
            />

            <BranchDetails branch={branch} isCheckout />
          </div>
        </Modal>
      )}
    </>
  );
};

export default BranchDetailsPopup;
